import { ExperianMobileWaitView } from './_shared/ExperianMobileWaitView';

export interface IdpOtpStepProps {
  onRefresh: () => void;
}

/**
 * Rendered when the backend's IDP state machine reports `submit_otp`.
 *
 * Per DoseSpot's V2 IDP workflow, the only out-of-band mobile verification
 * actually used in production is Experian's `IDCapture` SMS link flow — there
 * is no code for the clinician to type back into our app. The backend still
 * exposes this state as `submit_otp` (its historical name) but the clinician
 * action is "complete the Experian flow on your phone." This component
 * therefore renders the Experian wait view rather than an OTP-entry form.
 */
export function IdpOtpStep({ onRefresh }: IdpOtpStepProps) {
  return <ExperianMobileWaitView onRefresh={onRefresh} />;
}
